import { IInteractionMetricsAvailable, InteractionMetric } from "@edgetier/watchtower-types";

/**
 * Verify if an interaction metric should be visible. Takes into consideration the metric availability from
 * API and a feature flag when is specified
 * @param interactionMetricsAvailable
 * @param metric
 * @param featureFlag
 */
export const checkMetricAvailable = (
    interactionMetricsAvailable: IInteractionMetricsAvailable,
    metric: InteractionMetric,
    featureFlag?: boolean
) => {
    const [currentMetric] = Object.entries(interactionMetricsAvailable).filter(([key, _value]) => key === metric);

    // When a metric isn't sent in the API response, we can consider it false
    if (typeof currentMetric === "undefined") return false;

    const [, metricIsAvailable] = currentMetric;
    return typeof featureFlag === "boolean" ? featureFlag && metricIsAvailable : metricIsAvailable;
};
